import React from "react";
import "./Header.css"

class Footer extends React.Component{

    render(){
        return(
            <div className = "footer">
                <p>© 2022 Parth Patel</p>
            </div>
        )
    }   
}

export default Footer;